// extracted by mini-css-extract-plugin
module.exports = {"detailsInfoTitle":"DetailsInfoTitle_detailsInfoTitle__1WtB_","infoRow":"DetailsInfoTitle_infoRow__2KjdY"};